<template>
    <div class="main">
        <c-panel title="CONFIGURAÇÕES DE GRUPOS — ENSINO HÍBRIDO" titleIcon="fas fa-users">
            <el-alert type="info" :closable="false" class="u-mb-15"
                title="Define como as turmas serão divididas em grupos e com que regime de rodízio."
                description="A configuração é o molde; os grupos concretos de cada turma são gerados na tela Grupos por Turma."></el-alert>

            <el-row class="u-mb-15" :gutter="10">
                <el-col :xs="24" :sm="10">
                    <el-input v-model="filtro.nome" placeholder="Pesquisar configuração..." @keyup.native.enter="carregar"></el-input>
                </el-col>
                <el-col :xs="24" :sm="8">
                    <el-select v-model="filtro.periodo_letivo_id" clearable placeholder="Período letivo" style="width: 100%;" @change="carregar">
                        <el-option v-for="p in periodos" :key="p.id" :value="p.id" :label="p.nome"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="6" class="u-text-right">
                    <router-link v-if="podeEscrever" to="/admin/grupo-aluno/configuracao/cadastro" class="btn-new-register">
                        <el-button type="primary">NOVA CONFIGURAÇÃO</el-button>
                    </router-link>
                </el-col>
            </el-row>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Configuração</th>
                            <th style="width: 110px;">Escopo</th>
                            <th style="width: 90px;" class="u-text-center">Grupos</th>
                            <th style="width: 150px;">Divisão</th>
                            <th style="width: 130px;">Rodízio</th>
                            <th style="width: 100px;" class="u-text-center">Situação</th>
                            <th style="width: 150px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="c in items" :key="c.id">
                            <td>
                                {{ c.nome }}
                                <div v-if="c.modalidade || c.matriz_etapa">
                                    <small class="u-text-muted">
                                        <span v-if="c.modalidade">{{ c.modalidade.nome }}</span>
                                        <span v-if="c.matriz_etapa"> · {{ c.matriz_etapa.nome }}</span>
                                    </small>
                                </div>
                            </td>
                            <td>{{ c.escopo === 'rede' ? 'Rede' : 'Escola' }}</td>
                            <td class="u-text-center">{{ c.qtd_grupos }}</td>
                            <td>{{ rotulo(c.criterio_divisao) }}</td>
                            <td>{{ rotulo(c.regime_rodizio) }}</td>
                            <td class="u-text-center">{{ c.situacao ? 'Ativa' : 'Inativa' }}</td>
                            <td class="u-text-center acao">
                                <router-link :to="'/admin/grupo-aluno/turmas?configuracao=' + c.id" class="link-icon u-mr-10" style="color: rgba(0,0,0,.87) !important;">
                                    <el-button title="Gerar/ajustar grupos" icon="el-icon-s-operation" size="mini" plain></el-button>
                                </router-link>
                                <router-link v-if="podeEscrever" :to="'/admin/grupo-aluno/configuracao/edit/' + c.id" class="link-icon u-mr-10" style="color: rgba(0,0,0,.87) !important;">
                                    <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                                </router-link>
                                <el-button v-if="podeEscrever" @click="excluir(c.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                            </td>
                        </tr>
                        <tr v-if="items.length === 0"><td colspan="7" class="u-text-center">Nenhuma configuração cadastrada.</td></tr>
                    </tbody>
                </table>
                <div v-if="!statusList" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>
            </div>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO H — item 122. Interface para `api/configuracao-grupo-aluno`. */
import { periodosLetivosMixin } from '@/shared/periodos-letivos'
export default {
    mixins: [periodosLetivosMixin],
    data: () => ({ statusList: false, filtro: { nome: '', periodo_letivo_id: '' }, items: [] }),
    computed: {
        podeEscrever () { return [0, 1, 3, 4, 5, 6, 7, 9, 12].includes(parseInt(this.$store.state.user.tipo)) }
    },
    mounted () {
        this.filtro.periodo_letivo_id = this.$store.state.config.periodo ? this.$store.state.config.periodo.id : ''
        this.carregar()
    },
    methods: {
        carregar () {
            this.statusList = false
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/configuracao-grupo-aluno/getAllPaginate?page=1`,
                this.filtro, this.$store.getters.getHeaderAuth
            ).then(r => { this.items = r.data.data || []; this.statusList = true })
             .catch(e => this.$store.commit('throwException', e))
        },
        rotulo (v) {
            return { alfabetico: 'Alfabética', numero_chamada: 'Nº de chamada', manual: 'Manual',
                aleatorio: 'Sorteio', diario: 'Diário', semanal: 'Semanal',
                quinzenal: 'Quinzenal', sem_rodizio: 'Sem rodízio' }[v] || v
        },
        excluir (id) {
            this.$confirm('Excluir esta configuração?', 'Confirmação', {
                confirmButtonText: 'Excluir', cancelButtonText: 'Cancelar', type: 'warning'
            }).then(() => {
                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/configuracao-grupo-aluno/delete/${id}`,
                    this.$store.getters.getHeaderAuth
                ).then(r => {
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: 'Configuração excluída.', type: 'success' })
                    this.carregar()
                }).catch(e => this.$store.commit('throwException', e))
            }).catch(() => {})
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
